// Modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
// Styles
import * as styles from './DescriptionTextBlock.scss';
import { DEFAULT_DESCRIPTION_LENGTH } from '../../constants';

class DescriptionTextBlock extends Component {
  state = {
    descriptionIsOpen: false,
    isDifferenceHight: false,
    isWillMoreText: false
  };

  componentDidMount() {
    requestAnimationFrame(() => {
      requestAnimationFrame(this.calcHeightContent);
    });
  }

  shouldComponentUpdate(nextState) {
    const openStateIsChanged = nextState.descriptionIsOpen !== this.state.descriptionIsOpen;
    const openDifferenceHight = nextState.isDifferenceHight !== this.state.isDifferenceHight;
    const localeIsChanged = nextState.locale !== this.props.locale;
    return (openStateIsChanged || localeIsChanged || openDifferenceHight);
  }

  calcHeightContent = () => {
    const content = this.contentWrapper;
    const contentHeight = content.getBoundingClientRect().height;
    const parentHeight = content.parentNode.getBoundingClientRect().height;

    const isWillMoreText = contentHeight >= DEFAULT_DESCRIPTION_LENGTH;
    const isDifferenceHight = contentHeight <= parentHeight;

    this.setState({ isDifferenceHight, isWillMoreText });
  };

  handleClickMoreButton = (evt) => {
    evt.preventDefault();
    this.toggleDescription(!this.state.descriptionIsOpen);
  };

  toggleDescription = (status) => this.setState({ descriptionIsOpen: status });


  renderMoreButton = () => (
    <button onClick={this.handleClickMoreButton}>
      {this.props.translate('SEOsearch', this.state.descriptionIsOpen ? 'hide' : 'showMore')}
    </button>
  );

  render() {
    const TitleTag = this.props.titleTag || 'div';
    const { translate, isTranslate, descriptionData, toggleDescriptionTranslation } = this.props;

    return (
      // eslint-disable-next-line max-len
      <div className={cx(styles.wrapText, this.props.className, { [styles.withOutButton]: this.state.isDifferenceHight, [styles.willMoreText]: this.state.isWillMoreText })}>
        <div className={cx(styles.titleWrapper,
          { [styles.translate]: isTranslate && descriptionData.translatedRequired })}
        >
          <TitleTag className={styles.title}>
            {
              this.props.isTitleTranslated
                ? this.props.title
                : this.props.translate('companyPage', this.props.title)
            }
          </TitleTag>
          {(isTranslate && descriptionData.translatedRequired) && (
            <div className={styles.translateDescriptionRow}>
              <button
                className={styles.showOriginalDescription}
                onClick={toggleDescriptionTranslation}
              >
                <span>
                  {translate('propertyDetails', 'multilingualDescription', descriptionData.showOriginal
                    ? 'showOriginalDescription'
                    : 'returnTranslation'
                  )}
                </span>
                &nbsp;
                <sub>Powered by Google</sub>
              </button>
            </div>
          )}
        </div>
        <div className={cx({ [styles.opened]: this.state.descriptionIsOpen })}>
        <pre id="pre" ref={ref => { this.contentWrapper = ref; }}>
            { this.props.contentText }
        </pre>
        </div>
        {!this.state.isDifferenceHight && this.renderMoreButton()}
      </div>
    );
  }
}

DescriptionTextBlock.propTypes = {
  className: PropTypes.string,
  locale: PropTypes.string,
  contentText: PropTypes.string,
  title: PropTypes.string,
  isTitleTranslated: PropTypes.bool,
  titleTag: PropTypes.string,
  translate: PropTypes.func,
  toggleDescriptionTranslation: PropTypes.func,
  description: PropTypes.object,
  descriptionData: PropTypes.object,
  isTranslate: PropTypes.bool
};

export default DescriptionTextBlock;
